<h1 mat-dialog-title>Vorschau / Beispiel Datensatz</h1>

<div mat-dialog-content>
    <div class="one-row">
        <div class="one-column" *ngIf="kunde.bezeichnung">
            <h3>Name</h3>
            <div>{{ kunde.bezeichnung }}</div>
        </div>
        <div class="one-column" *ngIf="kunde.kunde_nr_intern">
            <h3>Interne Nummer</h3>
            <div>{{ kunde.kunde_nr_intern }}</div>
        </div>
        <div class="one-column" *ngIf="kunde.plz">
            <h3>Postleitzahl</h3>
            <div>{{ kunde.plz }}</div>
        </div>
        <div class="one-column" *ngIf="kunde.ort">
            <h3>Wohnort</h3>
            <div>{{ kunde.ort }}</div>
        </div>
        <div class="one-column" *ngIf="kunde.strasse">
            <h3>Straße</h3>
            <div>{{ kunde.strasse }}</div>
        </div>
        <div class="one-column" *ngIf="kunde.telefon_1">
            <h3>Telefon</h3>
            <div>{{ kunde.telefon_1 }}</div>
        </div>
        <div class="one-column" *ngIf="kunde.telefon_2">
            <h3>Mobil</h3>
            <div>{{ kunde.mobil_1 }}</div>
        </div>
        <div class="one-column" *ngIf="kunde.email">
            <h3>E-Mail</h3>
            <div>{{ kunde.email }}</div>
        </div>
        <div class="one-column" *ngIf="kunde.kommentar">
            <h3>Kommentar</h3>
            <div>{{ kunde.kommentar }}</div>
        </div>
    </div>
</div>
<div align="end" mat-dialog-actions>
    <button (click)="dialogRef.close()" mat-button>Abbrechen</button>
    <button *kienePermission="[7002]" (click)="dialogRef.close(true)" color="primary" mat-flat-button>
        Hochladen
    </button>
</div>
